import UnavailableWarningView from './unavailableWarningView.html';
import * as styles from './unavailableWarning.module.scss';
class UnavailableWarningController {
    constructor() {
        this.styles = styles;
    }
}
export const UnavailableWarningComponent = {
    template: UnavailableWarningView,
    controller: UnavailableWarningController,
    controllerAs: '$ctrl',
    transclude: {
        'imageSlot': 'img',
        'descriptionSlot': '?description',
    },
    bindings: {
        title: '@',
        description: '@',
        linkUrl: '@',
        linkDescription: '@',
        descriptionTitle: '@',
    },
};
